// #region Includes
import { Component, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../../shared/services/globals.service';
import { v_LocationDetailBus } from '../../../shared/models/v_LocationDetailBus';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { AssignablePersonBus } from '@app/cp/shared/models/AssignablePersonBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { VisitsCountBus } from '@app/cp/shared/models/VisitsCountBus';
import { DispatchItemBus } from '@app/cp/shared/models/DispatchItemBus';
import { DispatchAssignmentGridBus } from '@app/cp/shared/models/DispatchAssignmentGridBus';
import { MessageInfoType } from '@app/cp/shared/enums/MessageInfoType';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { AzugaNearestVehicleBus } from '@app/cp/shared/models/AzugaNearestVehicleBus';
import { AssignTechMessageInfo } from '@app/cp/shared/models/AssignTechMessageInfo';
import { AssignTechDispatchBus } from '@app/cp/shared/models/AssignTechDispatchBus';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { AssignTechState } from '@app/cp/shared/enums/AssignTechState';
// #endregion

@Component({
    selector: 'cp-assign-tech',
    templateUrl: './assign-tech.component.html',
    styleUrls: ['./assign-tech.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AssignTechComponent extends BaseAppEditComponent<DispatchAssignmentBus, DispatchBoardService> {

    public pageSize = 2;
    // #region Constructor & In/Out
    constructor(globals: GlobalsService, svc_data: DispatchBoardService, private svc_dispatches: DispatchesService,  qry_rd: DQOIReferenceDataQuery, private svc_dqoi: DQOIService)
    {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.className = "DispatchAssignmentBus";
        this.saveMode = SaveMode.individual;
        this.state = AssignTechState.waitingForAction;
        this.appCode = "AssignTech";
    }

    radiusMiles = 25;
    @Output() titleChild = new EventEmitter<string>();
    @Output() cancel = new EventEmitter();
    @Input() techData: any;
    @Input() appLocation: number = 0;
    // #endregion
    @Input() isConstruction: boolean = false;
    // #region Vars
    state: AssignTechState;
    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any;
    fleetData: any;
    nearestTechsData: AzugaNearestVehicleBus[];
    nearestTechsDataLoading: boolean = false;
    searchParam: DispatchBoardSearch;
    location: string;
    dispatch: any;
    dispatchParam: DispatchItemBus;
    locationDetail: v_LocationDetailBus;
    latLong: any;
    techsVisited: VisitsCountBus[];

    allPeople: any;
    assignTechInfo: AssignTechMessageInfo;
    techs: AssignablePersonBus[];
    assignTechDispatch: AssignTechDispatchBus;
    techsAssigned: DispatchAssignmentGridBus[] = [];
    techToAssign: DispatchAssignmentGridBus;
    dqoiId: any;
    dqoiOpened: boolean = false;
    saving: boolean = false;
    // #endregion

    ngOnInit() {
        this.saving = false;
        this.getData();
    }
    get fromTarget(): any {
        return CommonFunctions.hasValue(this.dispatchParam) ? this.dispatchParam.from : 1;
    }
    // #region GetData
    getData() {
        this.selectedData = new DispatchAssignmentBus();
        this.titleChild.emit('Assign Tech');
        this.dispatchParam = new DispatchItemBus(this.techData.assignDispatch);
        this.dispatch = this.techData.assignDispatch;
        this.location = this.dispatch.locationId;
        this.latLong = { lat: 37.434899, lng: -122.141189 }; //{ lat: 41.716223, long: -87.846203 };
        this.searchParam = this.sch;
        this.searchParam.userId = this.globals.userId;
        this.selectedData.setNew(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId, this.dispatch.dispatchId);
        this.createForm();
        this.setForm();
        this.nearestTechsDataLoading = true;
        try {
            if (CommonFunctions.hasValue(this.dispatchParam.personToAssignId)) {
                this.svc_dispatches.getTech(this.dispatchParam.personToAssignId).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        let busObj: AssignablePersonBus = new AssignablePersonBus(info.primaryReturn);
                        this.checkAssignFromPerson(busObj);
                    }
                });
//                this.selectedData.assignedPersonId = this.dispatchParam.personToAssignId;
            }
        }
        catch{

        }
        this.svc_dispatches.getAssignTechInfo(this.dispatch.dispatchId).subscribe((info: AssignTechMessageInfo) => {
            if (!info.saveError) {
                this.assignTechInfo = new AssignTechMessageInfo(info);
                this.techsVisited = _.cloneDeep(this.assignTechInfo.techsVisited);
                this.locationDetail = _.cloneDeep(this.assignTechInfo.locationDetail);
                this.assignTechDispatch = _.cloneDeep(this.assignTechInfo.dispatch);
                if (CommonFunctions.hasValue(this.locationDetail)) {
                    this.getNearestVehicles();
                }
                if (CommonFunctions.hasValue(this.assignTechDispatch) && !CommonFunctions.hasGuidValue(this.assignTechDispatch.accountClassId)) {
                    this.acctClassDlg_show();
                }
            }
        });
    }

    getNearestVehicles() {
        let se: CommonParam = new CommonParam();
        se.addParam("lat", this.locationDetail.lat);
        se.addParam("lng", this.locationDetail.lng); // this.latLong.lng);
        if (!this.radiusMiles) { this.radiusMiles = 25; }
        se.addParam("radius", this.radiusMiles);
        se.addParam("withInTime", 240);
        se.addParam("locationId", this.locationDetail.locationId);
        this.svc_dispatches.getNearestVehicles(se).subscribe((info: BaseMessageInfo) => {
            this.nearestTechsDataLoading = false;
            if (!info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                let arr = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let azBusObj: AzugaNearestVehicleBus = new AzugaNearestVehicleBus(info.primaryReturn[i]);
                    //let tech = this.techsVisited.find(s => s.personId === azBusObj.person.personId);
                    //if (tech) {
                    //    azBusObj.visits = tech.visits;
                    //}
                    arr.push(azBusObj);
                }
                this.nearestTechsData = arr;
            }

        });
    }
    // #endregion

    // #region Form
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchAssignmentId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'assignedPersonId': new UntypedFormControl(),
            'assignedDate': new UntypedFormControl(),
            'assignedStatusId': new UntypedFormControl(),
            'isPrimary': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'requireFieldValidation': new UntypedFormControl(),
            'assignedByPersonId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchAssignmentId: this.selectedData.dispatchAssignmentId,
            dispatchId: this.selectedData.dispatchId,
            assignedPersonId: this.selectedData.assignedPersonId,
            assignedDate: this.selectedData.assignedDate,
            assignedStatusId: this.selectedData.assignedStatusId,
            isPrimary: this.selectedData.isPrimary,
            startDate: this.selectedData.startDate,
            requireFieldValidation: this.selectedData.requireFieldValidation,
            assignedByPersonId: this.selectedData.assignedByPersonId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId
        });
    }
    // #endregion

    // #region Used by Modal
    cancelClick() {
       this.cancel.emit(null);
    }
    get canSave(): boolean {
        return CommonFunctions.hasArrayValue(this.techsAssigned);
    }

    // #endregion

    // #region Events
    serviceTechCBOChanged(data: AssignablePersonBus) {
        data.canSelect = false;
        this.checkAssignFromPerson(data);
    }
    personDisplayValue: string = "";
    serviceTechSelected(data: AssignablePersonBus) {
        this.checkAssignFromPerson(data);
    }
    disabledTech(itemArgs: { dataItem: any, index: any }) {
        return !itemArgs.dataItem.canSelect;
    }

    // #endregion

    email(emailAddress: string) {
    }
    closeDQOI() {
        this.dqoiOpened = false;
    }
    detailsData: DispatchData;
    showDQOI(id: any) {
        //let data: DispatchData = new DispatchData();
        //data.viewDispatch.dispatchId = id;
        //this.detailsData = data;
        this.svc_dqoi.showDQOI(id);
        //this.dqoiId = "1:" + id;
        //this.dqoiOpened = true;
    }
    refreshDQOI() {
        this.svc_dqoi.refreshDQOI(this.fromTarget); // SearchTarget.dispatch);
    }
    convertData(data: any) {
        if (data) {
            for (let i = 0; i < data.length; i++) {
                data[i].displayDriveTime = data[i].googleDriveTime / 100;
            }
        }
        return data;
    }

    confirmMIDialog(e: ConfirmOutput) {
        let info: BaseMessageInfo = e.data;
        if (this.state === AssignTechState.awaitingConfirm) {
            if (e.dialogResult === CPDialogResult.ok) {
                this.state = AssignTechState.acceptedConfirm;
                this.addToAssignGrid(this.techToAssign);
                if (info.hasNonConfirmMessages) {
                    let title: string = "Assign Tech";// + (info.saveError ? "Error" : "Warning");
                    setTimeout(() => {
                        this.miShow("Assign Tech: Warning", info, info.primaryReturn, title, null, null);
                    });
                }
            }
            this.state = AssignTechState.waitingForAction;
        }
        else {

        }
    }
    assignFromNearest(data: AzugaNearestVehicleBus)
    {
        if (this.isInAssignedGrid(data.person.personId)) {
            return;
        }
        let busObj: DispatchAssignmentBus = new DispatchAssignmentBus();
        busObj.setFromForm(this.editForm.value);
        busObj.requireFieldValidation = data.person.requireClockInOut;
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this.dispatch.dispatchId);
        busObj.requireFieldValidation = data.person.requireClockInOut;
        busObj.assignedPersonId = data.person.personId;
        this.techToAssign = new DispatchAssignmentGridBus(busObj);
        this.techToAssign.person = new AssignablePersonBus(null);
        this.techToAssign.person.fullName = data.person.fullName;
        this.techToAssign.person.contactEmail = data.person.contactEmail;
        this.techToAssign.person.mainNumber = data.person.mainNumber;
        this.techToAssign.person.cellNumber = data.person.cellNumber;
        this.validate(busObj);
    }
    assignFromVisited(data: VisitsCountBus) {
        if (this.isInAssignedGrid(data.personId)) {
            return;
        }
        let busObj: DispatchAssignmentBus = new DispatchAssignmentBus();
        busObj.setFromForm(this.editForm.value);
        busObj.requireFieldValidation = data.requireClockInOut;
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this.dispatch.dispatchId);
        busObj.requireFieldValidation = data.requireClockInOut;
        busObj.assignedPersonId = data.personId;
        this.techToAssign = new DispatchAssignmentGridBus(busObj);
        this.techToAssign.person = new AssignablePersonBus(null);
        this.techToAssign.person.fullName = data.tech;
        this.techToAssign.person.contactEmail = data.contactEmail;
        this.techToAssign.person.mainNumber = data.mainNumber;
        this.techToAssign.person.cellNumber = data.cellNumber;
        this.validate(busObj);

        //this.editForm.patchValue({
        //    assignedPersonId: dataItem.personId
        //});

    }
excludeFromAssign: string = "";
    getExcludedFromAssign() : string {
        let ret: string = _.map(this.techsAssigned, 'assignedPersonId').toString();
        return ret;
    }
    isInAssignedGrid(personId: any): boolean {
        return this.techsAssigned.filter(s => s.assignedPersonId === personId).length > 0;
    }
    validate(busObj: DispatchAssignmentBus) {
        this.svc_dispatches.validate(busObj, "DispatchAssignment").subscribe((info: BaseMessageInfo) => {
            info = new BaseMessageInfo(info);
            if (info.hasConfirmMessages) {
                this.state = AssignTechState.awaitingConfirm;
                let title: string = "Assign Tech";// + (info.saveError ? "Error" : "Warning");
                info.primaryReturn = busObj;
                let okButtonText = info.saveError ? "" : "Assign Tech";
                this.miShow("Assign Tech Confirm: " + (info.saveError ? "Error" : "Warning"), info, info, title, null, okButtonText, MessageInfoType.confirm);
            }
            else {
                if (info.saveError || info.warning) {
                    let title: string = "Assign Tech";// + (info.saveError ? "Error" : "Warning");
                    let okButtonText = info.saveError ? "" : "Assign Tech";
                    this.miShow("Assign Tech: " + (info.saveError ? "Error" : "Warning"), info, busObj, title, null, okButtonText);
                }
                else {
                    this.addToAssignGrid(busObj);
                    this.globals.notifySuccess(this.techToAssign.person.fullName + " Can Be Assigned");
                }
            }
        });

    }
    addToAssignGrid(busObj: DispatchAssignmentBus) {
        this.techToAssign.setId(CommonFunctions.getGuid());
        this.techToAssign.isAdded = true;
        this.techsAssigned.push(this.techToAssign);
        this.excludeFromAssign = this.getExcludedFromAssign();
    }

    checkAssignFromPerson(data: AssignablePersonBus) {
        let busObj: DispatchAssignmentBus = new DispatchAssignmentBus(null);
        let dateNow = DateFunctions.getDateNow();
        busObj.setNew(this.globals.userId, dateNow, this.globals.companyId, this.globals.personId);
       // busObj.setFromForm(this.editForm.value);
        if (DateFunctions.isValidDate(this.editForm.value.startDate)) {
            busObj.startDate = this.editForm.value.startDate;
        }
        busObj.requireFieldValidation = data.requireClockInOut;
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this.dispatch.dispatchId);
        busObj.requireFieldValidation = data.requireClockInOut;
        busObj.assignedPersonId = data.personId;
        this.techToAssign = new DispatchAssignmentGridBus(busObj);
        this.techToAssign.person = new AssignablePersonBus(data);
        this.editForm.patchValue({
            assignedPersonId: null
        });

        this.validate(busObj);
    }
    removeAssignment(data: DispatchAssignmentGridBus) {
        this.techsAssigned = _.remove(this.techsAssigned, function (n) {
            return n.CID() !== data.CID();
        });
        let tech = this.techs.find(s => s.personId === data.assignedPersonId);
        if (tech) {
            tech.canSelect = true;
        }

    }

    // #region Save
    saveIndividual() {
        this.saving = true;
        if (CommonFunctions.hasArrayValue(this.techsAssigned)) {
            let techsToSave: DispatchAssignmentBus[] = [];
            for (let i = 0; i < this.techsAssigned.length; i++) {
                let temp: DispatchAssignmentGridBus = _.cloneDeep(new DispatchAssignmentGridBus(this.techsAssigned[i]));
                temp.person = null;
                let busObj: DispatchAssignmentBus = new DispatchAssignmentBus(temp);
                if (busObj.isAdded) {
                    busObj.setId(null);
                }
                if (CommonFunctions.hasValue(this.newDispatchStatusId)) {
                    busObj.newDispatchStatus = this.newDispatchStatusId;
                }
                busObj.setBeforeSave();
                techsToSave.push(busObj);
            }
            this.svc_dispatches.saveDispatchAssignments(techsToSave).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess("Tech(s) " + CommonValues.Message_SuccessfullyAssigned);
                    this.techsAssigned = [];
                    this.saving = false;
                    this.refreshDQOI();
                    this.cancelClick();
                }
                else {
                    this.saveError(info.message);
                    this.saving = false;
                }
            });
        }
    }
    // #endregion

    // #region Commented Out
    // #endregion
    newDispatchStatusId: any;
    checkSave() {
        this.newDispatchStatusId = null;
        if (this.assignTechDispatch.dispatchStatusId === CommonValues.Dispatch_ReadyForDispatch) {
            this.newDispatchStatusId = CommonValues.Dispatch_Dispatched;
            this.save();
        }
        else if (!this.isConstruction && this.assignTechDispatch.dispatchStatusId !== CommonValues.Dispatch_ReadyForBilling) {
            let msg: string = "You are adding a resource and the dispatch status is " + this.assignTechDispatch.dispatchStatus + ". Would you like to change it to Dispatched?";
            this.cnfShow(msg, CRUDActions.Update, null, "Change Dispatch Status","CHSTATUS",true);
        }
        else {
            this.save();
        }
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.code === "CHSTATUS") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.newDispatchStatusId = CommonValues.Dispatch_Dispatched;
            }
            this.save();
        }

    }
    acctClassDlg_param: CommonParam;
    acctClassDlg_show() {
        let param: CommonParam = new CommonParam();
        param.addParam("dispatchId", this.dispatch.dispatchId);
        this.acctClassDlg_param = param;
    }
    acctClassDlg_closed(e: ConfirmOutput) {
        this.acctClassDlg_param = null;
        if (e.dialogResult !== CPDialogResult.ok) {
            this.cancelClick();
        }
    }

}
